export default "__VITE_ASSET__DvEqY4e0__"